import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-21c481c1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "stats" }

import StatChart from "@/components/StatChart.vue"
  import { Card } from "@/types/index"
  import { computed } from "vue"

  
export default /*#__PURE__*/_defineComponent({
  props: {
    deck: null
  },
  emits: ["hoverStat", "unhover"],
  setup(__props: any) {

const props = __props as {
    deck: Card[]
  }

  

  const max = 9

  const statAValues = computed(() => {
    return statComputer("statA")
  })

  const statBValues = computed(() => {
    return statComputer("statB")
  })

  function statComputer(statName: "statA" | "statB") {
    let values = []
    for (let i = 0; i < max; i++) {
      let count = props.deck.filter((el) => el[statName] === i).length
      values[i] = count
    }
    // count values equal to or above maximum at index [max]
    values[max] = props.deck.filter((el) => el[statName] >= max).length
    return values
  }

  

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(StatChart, {
      "stat-values": _unref(statAValues),
      deckCardCount: __props.deck.length,
      "stat-icon": "bi-heart-fill",
      onHoverStat: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('hoverStat', { statName: 'statA', statValue: $event }))),
      onMouseleave: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('unhover')))
    }, null, 8, ["stat-values", "deckCardCount"]),
    _createVNode(StatChart, {
      "stat-values": _unref(statBValues),
      deckCardCount: __props.deck.length,
      "stat-icon": "bi-star-fill",
      onHoverStat: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('hoverStat', { statName: 'statB', statValue: $event }))),
      onMouseleave: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('unhover')))
    }, null, 8, ["stat-values", "deckCardCount"])
  ]))
}
}

})